import {
  StapleTable,
  StapleTableHeader,
  StapleTableCell,
  StapleTableRow,
  StapleTableHeading,
  StapleTableBody,
} from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useBrowsingReviewCarriersPageStore } from 'store/pages/rfq/initiate-rfq/browsing-review-carriers/pageStore';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';

interface PortfolioEntry {
  carrierLogoUrl: string;
  productLines: string[];
  portfolioNames: string[];
}

const PortfoliosByCarriersTableRow: React.FC<PortfolioEntry> = ({ carrierLogoUrl, productLines, portfolioNames }) => {
  return (
    <StapleTableRow>
      <StapleTableCell width="5rem">
        <img src={carrierLogoUrl} alt="Carrier logo" width="170px" height="auto" />
      </StapleTableCell>
      <StapleTableCell width="4rem">{productLines.join(', ')}</StapleTableCell>
      <StapleTableCell width="7rem">
        {portfolioNames.map((name) => (
          <div key={name}>{name}</div>
        ))}
      </StapleTableCell>
    </StapleTableRow>
  );
};

export const PortfoliosByCarriersTable: React.FC = observer(() => {
  const { selectedPortfoliosPresenters, getInitialData, isLoading } = useBrowsingReviewCarriersPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <StapleTable totalElements={selectedPortfoliosPresenters.length} loading={isLoading}>
      <StapleTableHeader>
        <StapleTableRow>
          <StapleTableHeading width="5rem">Carrier</StapleTableHeading>
          <StapleTableHeading width="4rem">Product Lines</StapleTableHeading>
          <StapleTableHeading width="7rem">Portfolios</StapleTableHeading>
        </StapleTableRow>
      </StapleTableHeader>
      <StapleTableBody>
        {selectedPortfoliosPresenters.map(({ carrierLogoUrl, portfoliosByProductLine }, index) => (
          <PortfoliosByCarriersTableRow
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            carrierLogoUrl={carrierLogoUrl}
            productLines={portfoliosByProductLine.map(
              ({ productLineId }) => PRODUCT_LINES_CONTENT_MAP[productLineId].label,
            )}
            portfolioNames={portfoliosByProductLine.flatMap(({ portfolioNames }) => portfolioNames)}
          />
        ))}
      </StapleTableBody>
    </StapleTable>
  );
});
